import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=2475f0d9&scoped=true&lang=html&"
import script from "./Alert.vue?vue&type=script&lang=js&"
export * from "./Alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2475f0d9",
  null
  
)

export default component.exports